'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getStoreTransfers(params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `store-transfers${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getStoreTransfer(id) {
    const data = {
      method: 'get',
      url: 'store-transfer/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async createStoreTransfer(json) {
    const data = {
      method: 'post',
      url: 'store-transfer',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Store transfer created successfully', 2000)
      return response.data;
    }
  },
  async updateStoreTransfer(json, id) {
    const data = {
      method: 'put',
      url: 'store-transfer/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Store transfer updated successfully', 2000)
      return true;
    }
  },
  async deleteStoreTransfer(id) {
    const data = {
      method: 'delete',
      url: 'store-transfer/' + id
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Store transfer deleted successfully', 2000)
      return true;
    }
  },
  async approveStoreTransfer(id) {
    const data = {
      method: 'patch',
      url: 'store-transfer-approve/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Store transfer approved successfully')
      return true;
    }
  },
  async getStoreTransferNextNo() {
    const data = {
      method: 'get',
      url: 'store-transferNextNo',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getStoreTransferDetails(id, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `store-transfer/${id}/details${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return {data: [], total: 0}
  },
  async createStoreTransferDetails(json) {
    const data = {
      method: 'post',
      url: 'store-transfer-details',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Product added to transfer', 2000)
      return true;
    }
  },
  async updateStoreTransferDetails(json, id) {
    const data = {
      method: 'put',
      url: 'store-transfer-details/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Transfer product updated', 2000)
      return true;
    }
  },
  async deleteStoreTransferDetails(id) {
    const data = {
      method: 'delete',
      url: 'store-transfer-details/' + id
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Transfer product deleted', 2000)
      return true;
    }
  },
}
